import Auth from './Auth';
import Login from './Login/Login';
import Register from './Register/Register';
import RegisterStepCompany from './Register/RegisterStepCompany.vue';
import RegisterStepComment from './Register/RegisterStepComment.vue';
import RegisterStepCompaniesList from './Register/RegisterStepCompaniesList.vue';
import RegisterStepAssociationRepresentative from './Register/RegisterStepAssociationRepresentative.vue';
import ForgotPassword from './ForgotPassword/ForgotPassword';

import store from '../../store';


const guard = (_, __, next) => {
  if (store.getters['user/isLoggedIn']) {
    next('/');
  } else {
    next();
  }
};

export default {
    path: '/auth',
    component: Auth,
    beforeEnter: guard,
    children: [
      {
        path: '',
        name: 'auth-login',
        component: Login,
      },
      {
        path: 'register',
        name: 'auth-register',
        component: Register,
      },
      {
        path: 'register-company',
        name: 'auth-register-company',
        component: RegisterStepCompany,
      },
      {
        path: 'register-companies-list',
        name: 'auth-register-companies-list',
        component: RegisterStepCompaniesList,
      },
      {
        path: 'register-association-representative',
        name: 'auth-register-association-representative',
        component: RegisterStepAssociationRepresentative,
      },
      {
        path: 'register-comment',
        name: 'auth-register-comment',
        component: RegisterStepComment,
      },
      {
        path: 'register-forgot-password',
        name: 'auth-register-forgot-password',
        component: ForgotPassword,
      },
    ],
  };